import Box from "ds/components/Box";
import Table from "ds/components/Table";
import TableHead from "ds/components/Table/Head";
import TableBody from "ds/components/Table/Body";
import TableBodyRow from "ds/components/Table/Row";
import TableCell from "ds/components/Table/Row/Cell";
import TableCellText from "ds/components/Table/Row/CellText";
import Typography from "ds/components/Typography";
import Badge from "ds/components/Badge";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";
import { PermissionMetadata } from "shared/Actions/types";

import styles from "./styles.module.css";

type PermissionsTableProps = {
  permissions: PermissionMetadata[];
  ariaLabel: string;
};

const PermissionsTable = ({ permissions, ariaLabel }: PermissionsTableProps) => {
  const showFullDescription = useShowFullDescriptionWithBackArrow(null);

  return (
    <Box className={styles.tableContainer}>
      <Table ariaLabel={ariaLabel} layout="auto">
        <TableHead>
          <TableCell role="rowheader" className={styles.headerCell}>
            <Typography tag="span" variant="p-t7">
              Action
            </Typography>
          </TableCell>
          <TableCell role="rowheader" className={styles.headerCell}>
            <Typography tag="span" variant="p-t7">
              Description
            </Typography>
          </TableCell>
          <TableCell role="rowheader" className={styles.headerCell}>
            <Typography tag="span" variant="p-t7">
              Subject
            </Typography>
          </TableCell>
        </TableHead>
        <TableBody>
          {permissions.map((permission, index) => (
            <TableBodyRow key={index}>
              <TableCell align="center">
                <TableCellText>{permission.name}</TableCellText>
              </TableCell>
              <TableCell>
                <ListEntitiesItemDescriptionMultipleLines
                  lines={1}
                  hasChevronLink
                  description={permission.description || ""}
                  onShowFullDescription={showFullDescription}
                />
              </TableCell>
              <TableCell>
                <Box align="center" fullWidth>
                  <Badge type="strong" variant="gray" text={permission.subject} textEllipsis />
                </Box>
              </TableCell>
            </TableBodyRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default PermissionsTable;
